@if (vm().isLoading) {
  <lib-skeleton-card-inprogress></lib-skeleton-card-inprogress>
} @else {
  @if (vm().items.length > 0) {
    <ion-accordion value="pendingDeliveryNoteInPaper">
      <ion-item
        slot="header"
        color="warning"
      >
        <ion-label>
          {{ 'freight.detail.delivery_notes_in_paper' | translate }}
          <strong>({{ vm().totalElements }})</strong>
        </ion-label>
      </ion-item>
      <div slot="content">
        @for (freight of vm().items; track freight.id) {
          <lib-freight-carrier-finished-card
            [freight]="freight"
            [hideColumns]="true"
          ></lib-freight-carrier-finished-card>
        } @empty {
          <lib-empty-result
            text="freight.general.documentation_up_to_date"
            icon="sentiment_satisfied_24dp.svg"
            variant="success"
          ></lib-empty-result>
        }
        @if (vm().totalElements > vm().items.length) {
          <ion-button
            fill="outline"
            size="small"
            expand="block"
            (click)="seeMore.emit()"
          >
            {{ 'freight.general.see_more' | translate }}
          </ion-button>
        }
      </div>
    </ion-accordion>
  } @else {
    <lib-empty-result
      text="freight.general.no_delivery_notes_paper_pending"
      icon="sentiment_satisfied_24dp.svg"
      variant="success"
    ></lib-empty-result>
  }
}
